import {
  commonABtest,
  commonABtestNoEncrypt,
  commonConfig,
  queryComConfig,
  queryProductConfig,
  queryUserUnionLoanAvaliable,
} from '@/appApi';
import { ProductType } from '@/AppGlobal';
import { BoolString } from '@/interface/KKC/withdrawal';
import { queryAppliedProduction, queryblackProduction } from '@/pages/CL/credit/api';
import { difference } from 'lodash-es';
import { ClInterestRateRange } from '../interface/CL/clCredit';
import { AppliedProduction } from '../interface/pub';
import { encrypt } from './Crypto';
import { getGlobalUserInfo } from './singletonUtils';

export const nacosGlobalStoreKey = 'nacos.config.store';

let store: Map<string, string>;
// 这里使用 Symbol.for 来避免命名冲突
if (window[nacosGlobalStoreKey]) {
  store = window[nacosGlobalStoreKey];
} else {
  store = new Map<string, string>();
  window[nacosGlobalStoreKey] = store;
}
const queryingPromise = new Map<string | string[], Promise<string | Map<string, string>>>();

async function getNacosConfig(configName: string[]): Promise<Map<string, string>>;
async function getNacosConfig(configName: string): Promise<string>;
async function getNacosConfig(configName: any) {
  if (configName instanceof Array) {
    if (configName.every((item) => store.has(item))) {
      // 当全部都存在时，直接返回结果
      return store;
    }

    console.log(configName, 'configName commonConfig');

    const querying = commonConfig(
      encrypt(JSON.stringify(difference(configName, Array.from(store.keys()))))
    )
      .then(({ configs }) => {
        configName.forEach((key) => {
          store.set(key, configs[key]);
        });
        return store;
      })
      .finally(() => {
        queryingPromise.delete(configName);
      });
    queryingPromise.set(configName, querying);
    return querying;
  }
  if (store.has(configName)) {
    return store.get(configName) || '';
  }
  const ifQuerying = hasQuerying(configName);
  if (ifQuerying) {
    return ifQuerying;
  }

  // 缓存中没有，发起请求
  const querying = commonConfig(encrypt(JSON.stringify([configName])))
    .then(({ configs }) => {
      store.set(configName, configs[configName]);
      return configs[configName];
    })
    .finally(() => {
      queryingPromise.delete(configName);
    });
  // 不拆散存储。1、场景比较少 2、每次拆散存储降低效率，但不是每次都能更好起效果。
  queryingPromise.set(configName, querying);
  return querying;
}

/**
 * 检查是否启用统一还款日
 *
 * 判断逻辑：
 * 1. 如果配置开关 pay.payCombinationLoanCheckSwitch 等于 BoolString.YES，则启用
 * 2. 如果配置开关关闭，但用户在白名单中，也启用
 *
 * @returns {Promise<boolean>} 是否启用联合贷款
 */
export async function checkIsUnionLoanEnabled(): Promise<boolean> {
  // 检查配置开关
  const configSwitchEnabled =
    (await getNacosConfig('pay.payCombinationLoanCheckSwitch')) === BoolString.YES;

  // 如果配置开关已启用，直接返回true
  if (configSwitchEnabled) {
    return true;
  }

  // 如果配置开关关闭，则检查白名单
  if (!configSwitchEnabled) {
    try {
      const { enabled } = await queryUserUnionLoanAvaliable();
      return enabled === BoolString.YES;
    } catch (error) {
      console.error('white list check failed:', error);
      return false;
    }
  }

  // 默认返回配置开关状态
  return configSwitchEnabled;
}

/**
 * 检查当前用户是否命中强制借新还旧白名单
 *
 * @returns {Promise<boolean>} 是否强制借新还旧
 */
export async function checkIsForcedBorrowNewRepayOldEnabled(): Promise<boolean> {
  try {
    const userInfo = await getGlobalUserInfo();
    const { enabled } = await commonABtestNoEncrypt(userInfo?.userId, 'forceBorrowNewRepayOld');
    return enabled === BoolString.YES;
  } catch (error) {
    console.error('forced borrow new repay old white list check failed:', error);
    // 合规控制采用 fail-closed：查询异常时按命中处理，避免用户绕过强制整合。
    return true;
  }
}

// 是否应该再次发起请求
function hasQuerying(configName: string): Promise<string> | undefined {
  // 1 to 1...n
  const queryingKeyMap = new Map<string, string | string[]>();
  const keysInQuerying = [...queryingPromise.keys()];
  keysInQuerying.forEach((key) => {
    if (key instanceof Array) {
      key.forEach((k) => {
        // 考虑覆盖问题，只有不存在的时候，才进行填充。否则优先单个
        if (queryingKeyMap.get(k) === undefined) {
          queryingKeyMap.set(k, key);
        }
      });
    } else {
      queryingKeyMap.set(key, key);
    }
  });

  if (queryingKeyMap.has(configName)) {
    return queryingPromise.get(queryingKeyMap.get(configName) as string | string[])?.then((res) => {
      if (res instanceof Map) {
        return res.get(configName) || '';
      }
      return res;
    });
  }
}

let appliedProd: {
  isApplyCl: BoolString;
  isApplyKkc: BoolString;
  isApplyCmc: BoolString;
} | null = null;
const getAppliedProduction = async () => {
  if (appliedProd) {
    return appliedProd;
  }
  return queryAppliedProduction().then((res: AppliedProduction) => {
    appliedProd = res;
    return res;
  });
};

// let blackProd: any = null;
// 判斷是否是黑名單
const getBlackProduction = async () =>
  // console.log(blackProd, '9099099090');
  // if (blackProd !== null) {
  //   console.log(blackProd, '直接拿緩存');
  //   return blackProd;
  // }
  queryblackProduction().then(
    (res: any) => {
      console.log(res, '909098989898');
      const blackProd = res;
      // setTimeout(() => {
      //   blackProd = null;
      // }, 6000);
      return blackProd;
    }
    // let blackProd = false
    // blackProd = res;
    //  return res
  );
// byClaude-start
// ****** 不免密abtest数据  ******* //
const abtestNoEncryptMap = new Map<string, 'Y' | 'N'>();
async function getAbTestConfigNoEncrypt(scene: string) {
  if (abtestNoEncryptMap.has(scene)) {
    return abtestNoEncryptMap.get(scene);
  }
  const userInfo = await getGlobalUserInfo();
  const abresult = await commonABtestNoEncrypt(userInfo?.userId, scene);
  abtestNoEncryptMap.set(scene, abresult.enabled);
  return abresult.enabled;
}
// byClaude-end

// ****** abtest数据  ******* //
const abtestMap = new Map<string, string>();
async function getAbTestConfig(scene: string) {
  if (abtestMap.has(scene)) {
    return abtestMap.get(scene);
  }
  const userInfo = await getGlobalUserInfo();
  const abresult = await commonABtest(userInfo?.userId, scene);
  abtestMap.set(scene, abresult.env);
  return abresult.env;
}

interface ComConfig {
  license: string;
  addressCn: string;
  addressEn: string;
  copyright: string;
  hotline: string;
  whatsapp: string;
  email: string;
  competitionLicense: string;
  [key: string]: string;
}
let comConfig: ComConfig;

const getComConfig = async () => {
  if (!comConfig) {
    const res: any = await queryComConfig();
    comConfig = res;
  }
  return comConfig;
};

let clInterestRateRange: ClInterestRateRange | null = null;

// 获取利率范围
const getClInterestRateRange = async () => {
  if (clInterestRateRange) {
    return clInterestRateRange;
  }
  clInterestRateRange = { minRate: '', maxRate: '' };
  await queryProductConfig(ProductType.CL).then((res: ClInterestRateRange) => {
    clInterestRateRange = { minRate: res?.minRate || '', maxRate: res?.maxRate || '' };
  });
  return clInterestRateRange;
};

let EIRset: boolean;

// 获取利率范围
const getEIRset = async () => {
  if ([true, false].includes(EIRset)) {
    return EIRset;
  }

  const res = await getNacosConfig('app.pay.interestCategory');
  EIRset = res !== 'APR';
  return EIRset;
};

// ****** abtest数据  ******* //

export {
  getAbTestConfig,
  getAbTestConfigNoEncrypt,
  getAppliedProduction,
  getBlackProduction,
  getClInterestRateRange,
  getComConfig,
  getEIRset,
  getNacosConfig,
};
